<div class="page">
    <div class="page-content">
        <div class="container text-center">
            <div class="row">
                <div class="col-md-12">
                    <div class="">
                        <div>
                            <div class="display-1 mb-5 font-weight-bold error-text">Unauthorized</div>
                            <h1 class="h3  mb-3 font-weight-bold">Bad Request Error!</h1>
                            <p class="h5 font-weight-normal mb-7 leading-normal">You don't have the permission to access this page</p>
                            <a class="btn btn-secondary" routerLink="/home">
                                <i class="fe fe-arrow-left-circle mr-1"></i>Back
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>